import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { HeaderComponent } from '../shared/header/header.component';
import { FooterComponent } from "../shared/footer/footer.component";
import { HomeService } from './home.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialog } from '@angular/material/dialog';
import { CompanyModalComponent } from '../company-modal/company-modal.component';
import { Observable } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { CompanyInfo, SectorDto } from '../shared/dto/models-dto';
import { MatCheckboxModule, MatCheckbox } from '@angular/material/checkbox';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, MatTooltipModule, FooterComponent, HeaderComponent, MatSelectModule, MatCheckboxModule, TranslateModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {

  companies: CompanyInfo[] = [];
  filteredCompanies: CompanyInfo[] = [];
  searchTerm: string = '';
  expandedCompanyId: number | null = null;

  dimensionLabels = [
    { key: "Cultural and Social Inclusiveness", label: "Cultural" },
    { key: "Integration and Meaningful Engagement", label: "Integration" },
    { key: "Leadership and Organizational Readiness", label: "Leadership" },
    { key: "Mentorship and Skill Development", label: "Mentorship" },
    { key: "Outcome and Continuous Improvement", label: "Outcome" },
  ];

  filters = [
    {
      title: 'Inclusion by dimension',
      name: 'dimension',
      open: false,
      dimensions: [
        { name: 'leadership', label: 'Leadership', rating: 0, hoverRating: 0 },
        { name: 'bintegration', label: 'Integration', rating: 0, hoverRating: 0 },
        { name: 'mentorship', label: 'Mentorship', rating: 0, hoverRating: 0 },
        { name: 'cultural', label: 'Cultural', rating: 0, hoverRating: 0 },
        { name: 'outcome', label: 'Outcome', rating: 0, hoverRating: 0 }
      ]
    },
    {
      title: 'Contract type',
      name: 'contract',
      open: false,
      options: [
        { value: 'fulltime', label: 'Full-time' },
        { value: 'parttime', label: 'Part-time' }
      ]
    },
    {
      title: 'Work modality',
      name: 'work',
      open: false,
      options: [
        { value: 'smart', label: 'Smart-working' },
        { value: 'person', label: 'In person job' },
        { value: 'hybrid', label: 'Hybrid' },
        { value: 'flexible', label: 'Flexible hours' }
      ]
    }
  ];
countries: any[] = [];
cities: any[] = [];
filteredCities: any[] = [];
sectors: SectorDto[] = [];
oggettiInterni : any[] = [];



selectedCountry: string = '';
selectedCities: string[] = [];
previousSelectedCities: string[] = [];
badgeFilter: boolean = false;
selectedSector: any = null;
  constructor(
    private homeService: HomeService, 
    private router: Router, 
    private dialog: MatDialog,  
    @Inject(PLATFORM_ID) private platformId: Object){}


ngOnInit(): void {

this.homeService.getCountries().subscribe({
  next: (data) => {
    this.countries = data;
  },
  error: (err) => console.error('Errore countries', err)
});

this.homeService.getCities().subscribe({
  next: (data) => {
    this.cities = data;
  },
  error: (err) => console.error('Errore cities', err)
});

this.homeService.getCompanies().subscribe({
  next: (data) => {
    this.sectors=data.map((company: CompanyInfo) => company.sector || []).flat().filter((sector, index, self) =>
      index === self.findIndex((s) => s.id === sector.id)
    );
    console.log('Sectors loaded:', this.sectors);
  },
  error: (err) => console.error('Errore sectors', err)
});



  this.homeService.getCompanies().subscribe({
    next: (data) => {
      
      this.companies = data;
      //this.filteredCompanies = this.companies.filter(company => !company.badge);
      this.filteredCompanies = this.companies;
      console.log('Aziende caricate:', this.companies);
    },
    error: (err) => {
      console.error('Errore caricamento aziende', err);
    }
  });
}

getDimensionScore(company: CompanyInfo, key: string): string {
  const score = company.dimensionScores?.[key];
  return score !== undefined ? score.toFixed(2) : 'N/A';
}



  toggleAccordion(index: number): void {
    this.filters[index].open = !this.filters[index].open;
  }

  onCountryChange(): void {
    this.selectedCities = [];
    
    if (this.selectedCountry) {
      this.filteredCities = this.cities.filter(city => city.country?.name === this.selectedCountry);
    } else {
      this.filteredCities = [];
    }
    
    this.applyFilters();
  }

  onCitiesChange(): void {
    const hasAllCities = this.selectedCities.includes('');
    const hasOtherCities = this.selectedCities.some(city => city !== '');
    const hadAllCities = this.previousSelectedCities.includes('');
    
    // Se All Cities e altre città sono selezionate contemporaneamente
    if (hasAllCities && hasOtherCities) {
      // Se prima avevamo All Cities, significa che abbiamo cliccato un'altra città
      if (hadAllCities) {
        this.selectedCities = this.selectedCities.filter(city => city !== '');
      }
      // Se prima non avevamo All Cities, significa che abbiamo cliccato All Cities
      else {
        this.selectedCities = [''];
      }
    }
    // Se niente è selezionato, torna a All Cities
    else if (this.selectedCities.length === 0) {
      this.selectedCities = [''];
    }
    
    // Salva lo stato corrente per il prossimo cambio
    this.previousSelectedCities = [...this.selectedCities];
    
    this.applyFilters();
  }

applyFilters(): void {
  const term = this.searchTerm.toLowerCase();

  const inclusionFilter = this.filters.find(f => f.name === 'inclusionIndex');
  const inclusionValue = inclusionFilter && 'value' in inclusionFilter ? inclusionFilter.value : 0;

  const dimensionFilter = this.filters.find(f => f.name === 'dimension');
  const dimensions = dimensionFilter?.dimensions ?? [];

  const filtered = this.companies.filter(company => {
    if (term && !company.name.toLowerCase().includes(term)) {
      return false;
    }

    if (this.selectedCountry && (company.country?.name ?? company.city?.country?.name) !== this.selectedCountry) {
      return false;
    }

    // Filter by selected cities (if not 'All Cities')
    if (this.selectedCities.length > 0 && !this.selectedCities.includes('')) {
      if (!company.city?.name || !this.selectedCities.includes(company.city.name)) {
        return false;
      }
    }

    // Filter by selected sector
    if (this.selectedSector && company.sector?.id !== this.selectedSector.id) {
      return false;
    }

    if (this.badgeFilter && !company.badge) {
      return false;
    }

    for (const dim of dimensions) {
      if (dim.rating > 0) {
        let key = '';
        switch (dim.name) {
          case 'leadership':
            key = 'Leadership and Organizational Readiness';
            break;
          case 'bintegration':
            key = 'Integration and Meaningful Engagement';
            break;
          case 'mentorship':
            key = 'Mentorship and Skill Development';
            break;
          case 'cultural':
            key = 'Cultural and Social Inclusiveness';
            break;
          case 'outcome':
            key = 'Outcome and Continuous Improvement';
            break;
          default:
            continue;
        }

       const companyScore = company.dimensionScores?.[key];
        if (companyScore === undefined || companyScore < dim.rating) {
          return false;
        }

      }
    }

    return true;
  });

  this.filteredCompanies = filtered;
}


  loadCompanyDetails(id: number): void {
    this.homeService.getCompanyFullDetails(id).subscribe({
      next: (details) => {
        console.log('Dettagli azienda:', details);
      },
      error: (error) => {
        console.error('Errore durante il caricamento dei dettagli:', error);
      }
    });
  }

  toggleCompanyExpansion(id: number) {
    if (this.expandedCompanyId === id) {
      this.expandedCompanyId = null;  
    } else {
      this.expandedCompanyId = id;    
    }
  }

  getColor(value: number | undefined): string {
    if (value == null) return 'transparent'; 
    if (value >= 1 && value <= 1.9) return 'red';
    if (value >= 2 && value <= 2.9) return '#d99c32';
    if (value >= 3 && value <= 3.9) return 'blue';
    if (value >= 4 && value <= 5) return 'green';
    return 'transparent'; 
  }

  goToAllCompanies() {
    this.router.navigate(['/all-companies']);
  }

  openCompanyModal(company: CompanyInfo) {
    this.dialog.open(CompanyModalComponent, {
      maxWidth: '1100px',
      maxHeight: '90vh',
      panelClass: 'company-modal-panel',
      data: company
    });

  }

  badgeCheckFilter(){
    console.log(this.badgeFilter);
    this.badgeFilter = !this.badgeFilter;
    this.applyFilters();
  }

}

